export enum API_ENDPOINTS {
  API = 'api',
  SEARCH = 'search',
  GMX_QUERY = 'query',
}
